import React from "react";
import Chart from "react-apexcharts";

const BarChartComponent = ({ data = [], themeMode = "light" }) => {
    const filteredData = data.filter((item) => item.value > 0);
    const categories = filteredData.map((item) => item.time || "N/A");
    const seriesData = filteredData.map((item) => item.value);
    // const categories = data.length > 0 ? data.map((item) => item.time || "N/A") : [];
    // const seriesData = data.length > 0 ? data.map((item) => item.value || 0) : [];
    const columnWidth = categories.length < 5 ? "30%" : "50%";
    const chartOptions = {
        chart: {
            type: "bar",
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                columnWidth, // Dinamik kolon genişliği
                borderRadius: 5,
            },
        },
        grid: {
            borderColor: themeMode === "dark" ? "#FFFFFF" : "#000000",
            strokeDashArray: 3,
        },
        xaxis: {
            categories,
            labels: {
                style: {
                    colors: themeMode === "dark" ? "#FFFFFF" : "#000000",
                },

            },
            offsetX:10
        },
        yaxis: {
            labels: {
                style: {
                    colors: themeMode === "dark" ? "#FFFFFF" : "#000000",
                },
            },
        },
        tooltip: {
            theme: themeMode === "dark" ? "dark" : "light",
        },
        colors: ["#264F73", "#457AA6", "#104E8B", "#1B3F8B", "#3A66A7"], 
    };

    const chartSeries = [
        {
            name: "Value",
            data: seriesData,
        },
    ];

    return (
        <div className="w-[100%] "style={{ height: 200 }}>
            <Chart  key={categories.join("-") + seriesData.join("-")} options={chartOptions} series={chartSeries} type="bar" height="100%" width="100%" />
        </div>
    );
};

export default BarChartComponent;
